import { defineAsyncComponent } from 'vue';

import { toPlugin, type ComponentType, type Plugin } from '@bv/helpers/components';

export { BvCallWidget, BvCallDetails, BvDialPad, BvQuickDial } from './call';

export const voipArray: ComponentType[] = [
  {
    name: 'BvCallDetails',
    component: defineAsyncComponent(() => import('@bv/components/voip/call/BvCallDetails.vue')),
  },
  {
    name: 'BvCallWidget',
    component: defineAsyncComponent(() => import('@bv/components/voip/call/widget/BvCallWidget.vue')),
  },
  {
    name: 'BvDialPad',
    component: defineAsyncComponent(() => import('@bv/components/voip/call/dial-pad/BvDialPad.vue')),
  },
  {
    name: 'BvQuickDial',
    component: defineAsyncComponent(() => import('@bv/components/voip/call/dial-pad/BvQuickDial.vue')),
  },
];

export const voip: Plugin<[]> = toPlugin(voipArray);

export default voip;
